// src/socket.js
import { io } from "socket.io-client";
const SOCKET_SERVER_URL = "http://localhost:5353";
// const SOCKET_SERVER_URL = "http://103.189.173.7:3345";
let socket;
export const initializeSocket = (options = {}) => {
  if (!socket) {
    socket = io(SOCKET_SERVER_URL);
  }
};
export const getSocket = () => {
  if (!socket) {
    initializeSocket();
  }
  return socket;
};
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
